/**
 * Copies text to the clipboard, resolving to whether it worked.
 *
 * Prefers the async Clipboard API and falls back to selecting the source input and running
 * the deprecated execCommand, which is the only option outside a secure context.
 */
export function copyToClipboard(
    text: string,
    input: HTMLInputElement | null
): Promise<boolean> {
    if (input) {
        input.focus();
        input.select();
    }

    let clipboard = (navigator as any).clipboard;

    if (clipboard && typeof clipboard.writeText === 'function') {
        return clipboard.writeText(text).then(
            () => true,
            () => copyFromSelection()
        );
    }

    return Promise.resolve(copyFromSelection());
}

function copyFromSelection(): boolean {
    try {
        return document.execCommand('copy');
    } catch (e) {
        return false;
    }
}

export default copyToClipboard;
